
import React, { useState, useEffect } from "react";
import PopoverInput from "./inner/popoverInput.jsx";
const MAX_ROOMS = 8;
const MAX_ADULTS_IN_ROOM = 6;
const MAX_CHILDREN_IN_ROOM = 4;
const MAX_INFANTS_IN_ROOM = 2;
const CHILD_AGES = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];

const minus_icon = <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 12H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
</svg>;
const plus_icon = <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 6V18M6 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
</svg>;

const ChildAgePicker = ({ age, roomIdx, childIdx, events }) => {
    return <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 pl-3 border-solid border-primary border-l">
            <div className="text-content_3">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C8.27232 2 5.14012 4.54955 4.25203 8H3.5C2.67157 8 2 8.67157 2 9.5C2 10.3284 2.67157 11 3.5 11H4.06189C4.55399 14.9463 7.92038 18 12 18C16.0796 18 19.446 14.9463 19.9381 11H20C20.8284 11 21.5 10.3284 21.5 9.5C21.5 8.67157 20.8284 8 20 8H19.748C18.8599 4.54955 15.7277 2 12 2ZM12 2C12 5.31371 9.31371 8 6 8H4.5M12 2C12 5.31371 14.6863 8 18 8H19.5M18 22C18 20.208 17.2144 18.5994 15.9687 17.5M6 22C6 20.208 6.78563 18.5994 8.03126 17.5M9 10V10.01M15 10V10.01M12 15C12.5523 15 13 14.5523 13 14H11C11 14.5523 11.4477 15 12 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
            <span className="text-sm text-primary">Age of Child {childIdx + 1}</span>
        </div>
        <div className="flex items-center gap-1">
            <select className="form-input" value={age} onChange={e => events.setChildAge(roomIdx, childIdx, parseInt(e.target.value))}>
                {CHILD_AGES.map((x) => {
                    return <option key={x}>{x}</option>;
                })}
            </select>
        </div>
    </div>
}
const Room = ({ room, roomIdx, events }) => {
    const hasOneAdult = room.adults == 1;
    const hasMaxAdultsInRoom = room.adults == MAX_ADULTS_IN_ROOM;
    const hasNoChildrem = room.children.length == 0;
    const hasMaxChildrenInRoom = room.children.length == MAX_CHILDREN_IN_ROOM;
    const hasNoInfants = room.infants == 0;
    const hasMaxInfantsInRoom = room.infants == MAX_INFANTS_IN_ROOM;

    return (<div className="mb-6 border-2 border-dotted border-redsea_main p-4 rounded-[8px]">
        <h4 className="text-md font-semibold text-content_2 mb-4">Room {roomIdx + 1}</h4>
        <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
                <span className="text-md text-primary">Adults</span>
            </div>
            <div className="flex items-center gap-1">
                <button type="button" onClick={() => events.removeAdult(roomIdx)}
                    disabled={hasOneAdult}
                    className={"form-quantity-button " + (hasOneAdult ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                    {minus_icon}
                </button>
                <span className="text-lg font-bold text-secondary w-[30px] text-center">{room.adults}</span>
                <button type="button" onClick={() => events.addAdult(roomIdx)}
                    disabled={hasMaxAdultsInRoom}
                    className={"form-quantity-button " + (hasMaxAdultsInRoom ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                    {plus_icon}
                </button>
            </div>
        </div>


        <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">

                <span className="text-md text-primary">Children</span>
            </div>
            <div className="flex items-center gap-1">
                <button type="button" onClick={() => events.removeChild(roomIdx)}
                    disabled={hasNoChildrem}
                    className={"form-quantity-button " + (hasNoChildrem ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                    {minus_icon}
                </button>
                <span className="text-lg font-bold text-secondary w-[30px] text-center">{room.children.length}</span>
                <button type="button" onClick={() => events.addChild(roomIdx)}
                    disabled={hasMaxChildrenInRoom}
                    className={"form-quantity-button " + (hasMaxChildrenInRoom ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                    {plus_icon}
                </button>
            </div>
        </div>

        {room.children.map((age, childIdx) => {
            return <ChildAgePicker age={age} roomIdx={roomIdx} childIdx={childIdx} key={childIdx} events={events} />
        })}

        <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">

                <span className="text-md text-primary">Infants</span>
            </div>
            <div className="flex items-center gap-1">
                <button type="button" onClick={() => events.removeInfant(roomIdx)}
                    disabled={hasNoInfants}
                    className={"form-quantity-button " + (hasNoInfants ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                    {minus_icon}
                </button>
                <span className="text-lg font-bold text-secondary w-[30px] text-center">{room.infants}</span>
                <button type="button" onClick={() => events.addInfant(roomIdx)}
                    disabled={hasMaxInfantsInRoom}
                    className={"form-quantity-button " + (hasMaxInfantsInRoom ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                    {plus_icon}
                </button>
            </div>
        </div>
    </div>);
}
const PaxFooter = ({ close }) => {
    return <div className="text-center">
        <button className="btn btn-pri" onClick={() => close()}>Close</button>
    </div>;
}

const PaxPicker = ({ rooms, onChange }) => {

    if (rooms.length == 0) {
        rooms = [{ adults: 1, children: [], infants: 0 }];
    }
    const [isOpen, setIsOpen] = useState(false);
    const removeRoom = () => {
        var newARr = [...rooms];
        newARr.pop();
        onChange(newARr);
    };

    const addRoom = () => {
        onChange([...rooms, { adults: 1, children: [], infants: 0 }]);
    };

    const addAdult = (roomIdx) => {
        var newArr = [...rooms];
        newArr[roomIdx].adults++;
        onChange(newArr);
    };

    const removeAdult = (roomIdx) => {
        var newArr = [...rooms];
        newArr[roomIdx].adults--;
        onChange(newArr);
    };

    const addChild = (roomIdx) => {
        var newArr = [...rooms];
        var childArr = newArr[roomIdx].children;
        childArr.push(2);
        onChange(newArr);
    };

    const removeChild = (roomIdx) => {
        var newArr = [...rooms];
        var childArr = newArr[roomIdx].children;
        childArr.pop();
        onChange(newArr);
    };

    const setChildAge = (roomIdx, childIdx, age) => {
        var newArr = [...rooms];
        newArr[roomIdx].children[childIdx] = age;
        onChange(newArr);
    };

    const addInfant = (roomIdx) => {
        var newArr = [...rooms];
        newArr[roomIdx].infants++;
        onChange(newArr);
    };

    const removeInfant = (roomIdx) => {
        var newArr = [...rooms];
        newArr[roomIdx].infants--;
        onChange(newArr);
    };


    const getRoomSummary = () => {
        const totalRooms = rooms.length || 0;
        const totalAdults = rooms.reduce(
            (sum, room) => sum + room.adults,
            0
        );
        const totalChildren = rooms.reduce(
            (sum, room) => sum + room.children.length,
            0
        );
        const totalInfants = rooms.reduce(
            (sum, room) => sum + room.infants,
            0
        );

        if (totalRooms === 0) return "Choose your room(s)";

        return (
            totalRooms +
            " Rooms, " +
            totalAdults +
            " Adults, " +
            totalChildren +
            " Children, " +
            totalInfants +
            " Infants"
        );
    };


    const events = { addAdult, removeAdult, addChild, addInfant, removeChild, removeInfant, setChildAge }
    const currentRoomCount = rooms.length;
    const hasOneRoom = currentRoomCount == 1;
    const hasMaxRooms = currentRoomCount == MAX_ROOMS;
    return <PopoverInput footer={<PaxFooter close={() => setIsOpen(false)} />} isLoading={false} filterText={getRoomSummary()} doubleWidth={false} isOpen={isOpen} setIsOpen={setIsOpen}>
        <div className="text-secondary">
            <div className="mb-4">
                <h3 className="text-md font-semibold text-content_2">Choose your room(s)</h3>
            </div>
            <div className="flex items-center justify-between pb-4">
                <div className="flex items-center gap-2">

                    <span className="text-md text-primary">Room(s)</span>
                </div>
                <div className="flex items-center gap-1">
                    <button type="button" onClick={() => removeRoom()} disabled={hasOneRoom}
                        className={"form-quantity-button " + (hasOneRoom ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 12H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                    <span className="text-lg font-bold text-secondary w-[30px] text-center">{currentRoomCount}</span>
                    <button type="button" onClick={() => addRoom()} disabled={hasMaxRooms} className={"form-quantity-button " + (hasMaxRooms ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 6V18M6 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>
            </div>
            {rooms.map((x, i) => {
                return <Room room={x} roomIdx={i} key={i} events={events} />
            })}
        </div>
    </PopoverInput >
}
export default PaxPicker;
